import React, { useCallback, useEffect, useState } from "react";
import styles from "./Product.module.css";
import { useAuth } from "../../components/context/Auth";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
import { useNavigate, useParams } from "react-router-dom";
import ImageUploder from "../../components/updatedComponents/Product/ImageUploder";
import InputTag from "../../components/updatedComponents/FormComponents/InputTag";
import VerticalDropDown2 from "../../components/updatedComponents/FormComponents/VerticalDropDown2";
import KeyWordGen from "../../components/updatedComponents/Product/KeyWordGen";
import InputTextArea from "../../components/updatedComponents/Product/InputTextArea";
import InputRedio from "../../components/updatedComponents/FormComponents/InputRedio";
import fetchData from "../../APIsControll/apiControll";
import { handleFileData } from "../../APIsControll/apiControl2";
import Button from "../../components/updatedComponents/Dealers/Button";
import { AddTO } from "../../components/icons/Icon3";
import DrawerWrapper from "../../components/updatedComponents/layoutWrapper/DrawerWrapper";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import { validateFormForAddUpdateItem } from "../../validation/AddDealer";
import VerticalDropDown from "../../components/updatedComponents/FormComponents/VerticalDropDown";
const AddItem = () => {
  const [toggle, setToggle] = useState({
    modelToggle: false,
  });
  const [loading, setLoading] = useState({
    loading1: false,
    loading2: false,
  });
  const [url, seturl] = useState("");
  const [errors, setErrors] = useState({});
  const { product, collection } = useParams();
  const [SingleData, setSingleData] = useState({
    productimg: "",
    closeupimg: "",
    masterimg: "",
    thumbnail: "",
    pdfImage: "",
    stylesImgs: [],
    onlineVisibility: "",
    productionItem: "",
    sellersItem: "",
    secondaryUnit: "",
    product_name: "",
    collection_name: "",
    type_name: "",
    itemNo: "",
    itemSize: "",
    itemColor: "",
    itemAddMoreColor: [],
    metaTitle: "",
    metaDescription: "",
    metaKeywords: [],
    status: "",
    description: "",
    title: "",
    focusKeyword: "",
    underLabel: "",
    url: "",
    styles: [],
    types: [],
    items: [],
    recommendedItems: []
  });
  const { show } = useToast();
  const itemId = new URLSearchParams(window.location.search).get("itemId");
  const product_id = new URLSearchParams(window.location.search).get(
    "product_id"
  );
  const collection_id = new URLSearchParams(window.location.search).get(
    "collection_id"
  );
  const itemname = new URLSearchParams(window.location.search).get("itemname");
  const disabled =
    new URLSearchParams(window.location.search).get("disabled") === "true";
  const { mode } = useAuth();
  const navigate = useNavigate()
  const [modelContainer, setmodelContainer] = useState(null);

  const getItemData = useCallback(async () => {
    try {
      setLoading({ ...loading, loading1: true });
      const paylod = {
        prodId: product_id,
        collection_id: collection_id,
        _id: itemId,
      };
      const res = await fetchData(`content/item`, paylod);
      setSingleData({
        ...SingleData,
        closeupimg: res?.data?.itemImgDetails?.closeupimg
          ? res?.data?.itemImgDetails?.closeupimg
          : "",
        pdfImage: res?.data?.itemImgDetails?.pdfImage
          ? res?.data?.itemImgDetails?.pdfImage
          : "",
        masterimg: res?.data?.itemImgDetails?.masterimg
          ? res?.data?.itemImgDetails?.masterimg
          : "",
        productimg: res?.data?.itemImgDetails?.productimg
          ? res?.data?.itemImgDetails?.productimg
          : "",
        thumbnail: res?.data?.itemImgDetails?.thumbnail
          ? res?.data?.itemImgDetails?.thumbnail
          : "",
        stylesImgs: res?.data?.itemImgDetails?.stylesImgs
          ? res?.data?.itemImgDetails?.stylesImgs
          : [],
        onlineVisibility: res?.data?.onlineVisibility
          ? res?.data?.onlineVisibility
          : "",
        productionItem: res?.data?.productionItem
          ? res?.data?.productionItem
          : "",
        sellersItem: res?.data?.sellersItem ? res?.data?.sellersItem : "",
        secondaryUnit: res?.data?.secondaryUnit ? res?.data?.secondaryUnit : "",
        product_name: res?.data?.product_name ? res?.data?.product_name : "",
        collection_name: res?.data?.collection_name
          ? res?.data?.collection_name
          : "",
        type_name: res?.data?.materialType || res?.data?.type_name  /* ? res?.data?.type_name : "" */,
        itemNo: res?.data?.itemNo ? res?.data?.itemNo : "",
        itemSize: res?.data?.itemSize ? res?.data?.itemSize : "",
        itemColor: res?.data?.itemColor ? res?.data?.itemColor : "",
        itemAddMoreColor: res?.data?.itemAddMoreColor
          ? res?.data?.itemAddMoreColor
          : [],
        metaTitle: res?.data?.metaTitle ? res?.data?.metaTitle : "",
        metaDescription: res?.data?.metaDescription
          ? res?.data?.metaDescription
          : "",
        metaKeywords: res?.data?.metaKeywords ? res?.data?.metaKeywords : [],
        status: res?.data?.status ? res?.data?.status : "",
        description: res?.data?.description ? res?.data?.description : "",
        title: res?.data?.title ? res?.data?.title : "",
        underLabel: res?.data?.underLabel ? res?.data?.underLabel : "",
        focusKeyword: res?.data?.focusKeyword ? res?.data?.focusKeyword : "",
        url: res?.data?.url ? res?.data?.url : "",
        styles: res?.styles ? res?.styles : [],
        types: res?.types ? res?.types : [],
        items: res?.items ? res?.items : [],
        recommendedItems: res?.data?.recommendedItems ? res?.data?.recommendedItems : []
      });
      seturl(res?.data?.url ? res?.data?.url : "");
    } catch (error) {
      alert("Error: ");
    } finally {
      setLoading({ ...loading, loading1: false });
    }
  }, [SingleData, collection_id, itemId, loading, product_id]);


  useEffect(() => {
    getItemData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (e) => {
    try {
      const validationErrors = validateFormForAddUpdateItem(
        SingleData,
        // selectItem
      );
      if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        return;
      }
      const hasInvalid = SingleData.stylesImgs.some(
        (e) => !e.style_name || !e.demoimg
      );
      if (hasInvalid) {
        show("Style Name And Image is required", "error");
        return;
      }

      e.preventDefault();
      setLoading({ ...loading, loading2: true });
      const formdata = new FormData();
      formdata.append("itemNo", SingleData.itemNo.toUpperCase());
      formdata.append("product_name", SingleData.product_name || product.replace(/-/g, " "));
      formdata.append("product_id", product_id);
      formdata.append("collection_id", collection_id);
      formdata.append("materialType", SingleData.type_name);
      formdata.append("collection_name", SingleData.collection_name || collection.replace(/-/g, " "));
      formdata.append("itemSize", SingleData.itemSize);
      formdata.append("underLabel", SingleData.underLabel);
      formdata.append("itemColor", SingleData.itemColor);
      formdata.append("metaTitle", SingleData.metaTitle);
      formdata.append("metaDescription", SingleData.metaDescription);
      formdata.append("stylesImgsInfo", JSON.stringify(
        SingleData.stylesImgs.map((item) => ({
          style_name: item?.style_name,
          masterimg: item?.masterimg ? item?.masterimg : false,
          demoimg: typeof item?.demoimg === 'string' && item.demoimg.includes('content/items/')
            ? item.demoimg : ''
        })))
      );
      formdata.append("title", SingleData.title);
      formdata.append("description", SingleData.description);
      formdata.append("itemAddMoreColor", JSON.stringify(SingleData.itemAddMoreColor));
      formdata.append("metaKeywords", JSON.stringify(SingleData.metaKeywords));
      formdata.append("focusKeyword", JSON.stringify(SingleData.focusKeyword));
      formdata.append("onlineVisibility", SingleData.onlineVisibility);
      formdata.append("secondaryUnit", SingleData.secondaryUnit);
      formdata.append("productionItem", SingleData.productionItem);
      formdata.append("sellersItem", SingleData.sellersItem);
      formdata.append("status", SingleData.status);
      formdata.append("recommendedItems", JSON.stringify(SingleData.recommendedItems));
      formdata.append("url", url || SingleData.metaTitle);
      formdata.append("productimg", SingleData.productimg);
      formdata.append("closeupimg", SingleData.closeupimg);
      formdata.append("thumbnail", SingleData.thumbnail);
      formdata.append("pdfImage", SingleData.pdfImage);

      SingleData?.stylesImgs?.map((item) => (
        <>{formdata.append("demoimg", item.demoimg)}</>
      ));

      const res = await handleFileData(
        itemname ? `content/updateItem/${itemId}` : `content/addItem`,
        formdata
      );
      if (res.status === "success") {
        show(res.msg || res.message || res.data, "success");
        navigate(-1)
        return;
      }
      if (res.status === "failed") {
        show(res.msg || res.message || res.data, "error");
        return;
      } else {
        show("Error", "error");
      }
    } catch (error) {
      show("Error", "error");
    } finally {
      setLoading({ ...loading, loading2: false });
    }
  };

  useEffect(() => {
    const formatUrlFromMetaTitle = (metaTitle) => {
      return metaTitle.replace(/\s+/g, " ").split(" ").join("-").toLowerCase();
    };
    const formattedUrl = formatUrlFromMetaTitle(SingleData.metaTitle);
    seturl(formattedUrl);
  }, [SingleData]);


  const addNewImageUploader = () => {
    setSingleData((prevData) => ({
      ...prevData,
      stylesImgs: [
        ...prevData.stylesImgs,
        { style_name: "", demoimg: "", masterimg: false, },
      ],
    }));
  };

  const HandelRemove = (index) => {
    const updatedList = SingleData.stylesImgs.filter((_, i) => i !== index);
    setSingleData({
      ...SingleData,
      stylesImgs: updatedList,
    });
  };
  const allStylesUsed = SingleData?.stylesImgs?.length >= SingleData?.styles?.length;



  return (
    <div className={styles.Main_Layout}>
      <DrawerWrapper
        isOpen={toggle.modelToggle}
        onClose={() => setToggle({ ...toggle, modelToggle: false })}
      >
        {modelContainer}
      </DrawerWrapper>

      <div
        className={styles.Layout}
        style={{
          backgroundColor: mode ? "#2B2D31" : "#F8F9FC",
          color: mode ? "#fff" : "#000",
          cursor: disabled ? "not-allowed" : "",
        }}
      >
        {/* <form> */}
        <div className={styles.Top_bar_css}>
          <div className={styles.gobackClass}>
            <TopTabBar
              text={`Product / ${product} / ${collection} / ${itemname ? itemname : "Add Item"}`}
            />
          </div>
          <div className={styles.btn_Continer}>
            <div style={{ width: "120px" }}>
              <Button
                buttonText={itemname ? "Update" : "Create"}
                buttonBgColor={"#4164E3"}
                buttonTextColor={"#fff"}
                buttonIcon={<AddTO />}
                disabled={disabled}
                disabledButtonTextColor={"#fff"}
                disabledButtonBgColor={"#ccc"}
                buttonClick={handleSubmit}
                loading={loading.loading2}
              />
            </div>
          </div>
        </div>

        <div className={styles.form_continer}>
          {/* col - 1 */}
          <div className={styles.Col_sm}>
            <div
              className={styles.Col_sm_sub1}
              style={{
                backgroundColor: mode ? "#232529" : "#fff",
                color: mode ? "#fff" : "#000",
              }}
            >
              <div>
                <ImageUploder
                  image={SingleData.productimg}
                  labelText={"Item Image"}
                  setimage={(e) =>
                    setSingleData({ ...SingleData, productimg: e })
                  }
                  disabled={disabled}
                  error={errors.productimg}
                  loading={loading.loading1}
                />
                <ImageUploder
                  image={SingleData.closeupimg}
                  labelText={"Close-Up"}
                  setimage={(e) =>
                    setSingleData({ ...SingleData, closeupimg: e })
                  }
                  disabled={disabled}
                  error={errors.closeupimg}
                  loading={loading.loading1}
                />
              </div>
              <div>
                <ImageUploder
                  labelText={"Thumbnail"}
                  setimage={(e) =>
                    setSingleData({ ...SingleData, thumbnail: e })
                  }
                  image={SingleData?.thumbnail}
                  disabled={disabled}
                  error={errors.thumbnail}
                  loading={loading.loading1}
                />
                <ImageUploder
                  labelText={"PDF Image"}
                  setimage={(e) =>
                    setSingleData({ ...SingleData, pdfImage: e })
                  }
                  image={SingleData?.pdfImage}
                  disabled={disabled}
                  error={errors.pdfImage}
                  loading={loading.loading1}
                />
              </div>
            </div>
            <div > <span style={{ fontSize: "14px", fontWeight: "600", borderBottom: "1px solid" }}>Style Images </span>  </div>
            <div
              className={styles.Col_sm_sub4}
              style={{
                backgroundColor: mode ? "#232529" : "#fff",
                color: mode ? "#fff" : "#000",
              }}
            >
              {SingleData?.stylesImgs?.map((item, index) => {
                const selectedOptions = SingleData?.stylesImgs
                  .filter((_, i) => i !== index)
                  .map((img) => img.style_name);

                const availableOptions = SingleData?.styles
                  ?.filter((style) => !selectedOptions.includes(style.style_name))
                  ?.map((style) => ({
                    label: style.style_name,
                    value: style._id,
                  }));

                return (
                  <div key={item._id}>
                    <ImageUploder
                      setoption={(e) => {
                        const updatedImages = SingleData?.stylesImgs?.map(
                          (opction, i) =>
                            i === index ? {
                              ...opction,
                              style_name: e.label,
                              _id: SingleData?.styles?.find(
                                (item) => item.style_name === e
                              )?._id,
                            } : opction
                        );
                        setSingleData({
                          ...SingleData,
                          stylesImgs: updatedImages,
                        });
                      }}
                      handeremove={() => HandelRemove(index)}
                      value={item?.style_name}
                      image={item?.demoimg}
                      options={availableOptions}
                      setimage={(e) => {
                        const updatedImages = SingleData?.stylesImgs?.map(
                          (img, i) => (i === index ? { ...img, demoimg: e } : img)
                        );
                        setSingleData({
                          ...SingleData,
                          stylesImgs: updatedImages,
                        });
                      }}
                      disabled={disabled}
                      selectText={"Select Master Image"}
                    />
                    {
                      <div className={styles.select_image_chack}>
                        <div>{"Select Master Image"}</div>
                        <div>
                          <label className={styles.cl_checkbox}>
                            <input
                              type="checkbox"
                              checked={item.masterimg}
                              onChange={() => {
                                const updatedImages = SingleData?.stylesImgs?.map(
                                  (img, i) => ({
                                    ...img,
                                    masterimg: i === index,
                                  })
                                );
                                setSingleData({
                                  ...SingleData,
                                  stylesImgs: updatedImages,
                                });
                              }}
                              disabled={disabled}
                            />

                            <span></span>
                          </label>
                        </div>
                      </div>
                    }
                  </div>
                )
              })}

              <div style={{
                height: "auto",
                display: "flex",
                alignItems: "flex-end"
              }}>
                <Button
                  buttonText={"ADD"}
                  buttonBgColor={"#4164E3"}
                  buttonTextColor={"#fff"}
                  buttonIcon={<AddTO />}
                  disabledButtonTextColor={"#fff"}
                  disabledButtonBgColor={"#ccc"}
                  buttonClick={addNewImageUploader}
                  disabled={disabled || allStylesUsed}

                />
              </div>
            </div>
          </div>

          {/* col - 2 */}
          <div
            className={styles.Col_sm1}
            style={{
              backgroundColor: mode ? "#232529" : "#fff",
              color: mode ? "#fff" : "#000",
            }}
          >
            <div>
              <InputTag
                labelText={"Enter URL"}
                star={true}
                padding={"8px"}
                fontSize={"12px"}
                maxLength={10000}
                placeholderType={"text"}
                required={true}
                value={url}
                // warning={errors.metaTitle}
                disabled={true}
                onChange={(e) =>
                  setSingleData({ ...SingleData, metaTitle: e.target.value })
                }
                loading={loading.loading1}
              />
            </div>
            <div>
              <InputTag
                labelText={"Item Number"}
                star={true}
                padding={"8px"}
                fontSize={"12px"}
                maxLength={10000}
                placeholderType={"text"}
                required={true}
                value={SingleData?.itemNo.toUpperCase()}
                warning={errors.itemNo}
                onChange={(e) =>
                  setSingleData({ ...SingleData, itemNo: e.target.value })
                }
                disabled={disabled}
                loading={loading.loading1}
              />
            </div>
            <div>
              <InputTag
                labelText={"Title"}
                star={true}
                padding={"8px"}
                fontSize={"12px"}
                maxLength={10000}
                placeholderType={"text"}
                required={true}
                value={SingleData?.title}
                warning={errors.title}
                onChange={(e) =>
                  setSingleData({ ...SingleData, title: e.target.value })
                }
                disabled={disabled}
                loading={loading.loading1}
              />
            </div>
            <div>
              <InputTextArea
                lableText={"Description"}
                value={SingleData?.description}
                onChange={(e) =>
                  setSingleData({ ...SingleData, description: e.target.value })
                }
                disabled={disabled}
                minLength={50}
                warning={errors.description}
                loading={loading.loading1}
              />
            </div>
            <div>
              <InputTag
                labelText={"Size"}
                star={true}
                padding={"8px"}
                fontSize={"12px"}
                maxLength={10000}
                placeholderType={"text"}
                required={true}
                value={SingleData?.itemSize}
                onChange={(e) =>
                  setSingleData({ ...SingleData, itemSize: e.target.value })
                }
                disabled={disabled}
                warning={errors.itemSize}
                loading={loading.loading1}
              />
            </div>
            <div>
              <InputTag
                labelText={"Color"}
                padding={"8px"}
                star={true}
                fontSize={"12px"}
                maxLength={10000}
                placeholderType={"text"}
                required={true}
                value={SingleData?.itemColor}
                onChange={(e) =>
                  setSingleData({ ...SingleData, itemColor: e.target.value })
                }
                disabled={disabled}
                warning={errors.itemColor}
                loading={loading.loading1}
              />
            </div>
            <div>
              <div>
                <KeyWordGen
                  lableText={"Add More Color"}
                  setWords={(e) =>
                    setSingleData({ ...SingleData, itemAddMoreColor: e })
                  }
                  words={SingleData.itemAddMoreColor}
                  disabled={disabled}
                  errorText={errors.itemAddMoreColor}
                />
              </div>
            </div>
            <div>
              <VerticalDropDown2
                dropDownText={"--Select--"}
                label={"Under Label"}
                height={"37px"}
                fontSize={"12px"}
                value={SingleData.underLabel !== "" ? { label: SingleData.underLabel } : null}
                options={
                  [{ label: "Primary", value: "Primary" }, { label: "Accessories", value: "Accessories" }]
                }
                onchange={(label) => {
                  setSingleData({ ...SingleData, underLabel: label.value })
                }}
                errorText={errors.underLabel}
                disableOpen={disabled}
              />
            </div>
            <div>
              <VerticalDropDown2
                dropDownText={"--Select--"}
                label={"Select Type"}
                height={"37px"}
                fontSize={"12px"}
                value={SingleData.type_name !== "" ? { label: SingleData.type_name } : null}
                options={SingleData?.types?.map((item) => ({
                  label: item.type_name,
                  value: item.type_name,
                }))}
                onchange={(label) => {
                  setSingleData({ ...SingleData, type_name: label.value })
                }}
                disableOpen={disabled}
              />
            </div>
          </div>
          {/* col - 3 */}
          <div
            className={styles.Col_sm2}
            style={{
              backgroundColor: mode ? "#232529" : "#fff",
              color: mode ? "#fff" : "#000",
            }}
          >
            <div>
              <KeyWordGen
                lableText={"Keywords (Optional)"}
                setWords={(e) =>
                  setSingleData({ ...SingleData, metaKeywords: e })
                }
                words={SingleData.metaKeywords}
                disabled={disabled}
                loading={loading.loading1}
              />
            </div>
            <div>
              <InputTag
                labelText={"Meta Title"}
                star={true}
                padding={"8px"}
                fontSize={"12px"}
                maxLength={10000}
                placeholderType={"text"}
                required={true}
                // errorText={"use 60 letters only 137"}
                value={SingleData?.metaTitle}
                onChange={(e) =>
                  setSingleData({ ...SingleData, metaTitle: e.target.value })
                }
                disabled={disabled}
                warning={errors.metaTitle}
                loading={loading.loading1}
              />
            </div>
            <div>
              <InputTextArea
                star={true}
                // ErrorText={"Character limit 50-160*"}
                lableText={"Meta Description"}
                value={SingleData?.metaDescription}
                onChange={(e) =>
                  setSingleData({
                    ...SingleData,
                    metaDescription: e.target.value,
                  })
                }
                disabled={disabled}
                warning={errors.metaDescription}
                loading={loading.loading1}
              />
            </div>
            <div>
              <KeyWordGen
                lableText={"Focus Keywords"}
                setWords={(e) =>
                  setSingleData({ ...SingleData, focusKeyword: e })
                }
                words={SingleData?.focusKeyword}
                disabled={disabled}
                errorText={errors.focusKeyword}
                loading={loading.loading1}
              />
            </div>
            <div>

              <VerticalDropDown
                dropDownText={"--Select--"}
                label={"Recommended Items"}
                height={"37px"}
                fontSize={"12px"}
                value={SingleData.recommendedItems.map((item) => ({
                  label: item?.itemNo,
                  value: item?._id,
                  key: item?._id
                }))}
                options={SingleData.items.map((item) => ({
                  label: item.itemNo,
                  value: item._id,
                  kye: item._id
                }))}
                onchange={(selectedOptions) => {
                  const mappedItems = selectedOptions.map((opt) => ({
                    itemNo: opt.label,
                    _id: opt.value,
                  }));
                  setSingleData({
                    ...SingleData,
                    recommendedItems: mappedItems,
                  });

                }}
                multiple={true}
                disableOpen={disabled}
                errorText={errors.Selectitems}
              />
            </div>
            <div className={styles.main_readio_con}>
              <div className={styles.Redio_type_btn_con}>
                <div>
                  Online Visible  <span style={{ color: "red" }}>*</span>{" "}
                </div>
                <div className={styles.redio_btn_div}>
                  <div>
                    {" "}
                    <InputRedio
                      lableText={"Yes"}
                      name={"OnlineVisible"}
                      checked={SingleData?.onlineVisibility === "Active"}
                      onChange={() =>
                        setSingleData({
                          ...SingleData,
                          onlineVisibility: "Active",
                        })
                      }
                      disabled={disabled}
                    />
                  </div>
                  <div>
                    {" "}
                    <InputRedio
                      lableText={"No"}
                      name={"OnlineVisible"}
                      checked={SingleData?.onlineVisibility === "Disable"}
                      onChange={() =>
                        setSingleData({
                          ...SingleData,
                          onlineVisibility: "Disable",
                        })
                      }
                      disabled={disabled}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.Redio_type_btn_con}>
                <div>
                  Secondary Unit<span style={{ color: "red" }}>*</span>{" "}
                </div>
                <div className={styles.redio_btn_div}>
                  <div>
                    {" "}
                    <InputRedio
                      lableText={"Yes"}
                      name={"SecondaryUnit"}
                      checked={SingleData?.secondaryUnit === "Active"}
                      onChange={() =>
                        setSingleData({
                          ...SingleData,
                          secondaryUnit: "Active",
                        })
                      }
                      disabled={disabled}
                    />
                  </div>
                  <div>
                    {" "}
                    <InputRedio
                      lableText={"No"}
                      name={"SecondaryUnit"}
                      checked={SingleData?.secondaryUnit === "Disable"}
                      onChange={() =>
                        setSingleData({
                          ...SingleData,
                          secondaryUnit: "Disable",
                        })
                      }
                      disabled={disabled}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.Redio_type_btn_con}>
                <div>
                  Production Item<span style={{ color: "red" }}>*</span>{" "}
                </div>
                <div className={styles.redio_btn_div}>
                  <div>
                    {" "}
                    <InputRedio
                      lableText={"Yes"}
                      name={"ProductionItem"}
                      checked={SingleData?.productionItem === "Active"}
                      onChange={() =>
                        setSingleData({
                          ...SingleData,
                          productionItem: "Active",
                        })
                      }
                      disabled={disabled}
                    />
                  </div>
                  <div>
                    {" "}
                    <InputRedio
                      lableText={"No"}
                      name={"ProductionItem"}
                      checked={SingleData?.productionItem === "Disable"}
                      onChange={() =>
                        setSingleData({
                          ...SingleData,
                          productionItem: "Disable",
                        })
                      }
                      disabled={disabled}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.Redio_type_btn_con}>
                <div>
                  Status<span style={{ color: "red" }}>*</span>{" "}
                </div>
                <div className={styles.redio_btn_div}>
                  <div>
                    {" "}
                    <InputRedio
                      lableText={"Yes"}
                      name={"Status"}
                      checked={SingleData?.status === "Active"}
                      onChange={() =>
                        setSingleData({ ...SingleData, status: "Active" })
                      }
                      disabled={disabled}
                    />
                  </div>
                  <div>
                    {" "}
                    <InputRedio
                      lableText={"No"}
                      name={"Status"}
                      checked={SingleData?.status === "Disable"}
                      onChange={() =>
                        setSingleData({ ...SingleData, status: "Disable" })
                      }
                      disabled={disabled}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.Redio_type_btn_con}>
                <div>
                  Sellers Item<span style={{ color: "red" }}>*</span>{" "}
                </div>
                <div className={styles.redio_btn_div}>
                  <div>
                    {" "}
                    <InputRedio
                      lableText={"Yes"}
                      name={"SellersItem"}
                      checked={SingleData?.sellersItem === "Active"}
                      onChange={() =>
                        setSingleData({ ...SingleData, sellersItem: "Active" })
                      }
                      disabled={disabled}
                    />
                  </div>
                  <div>
                    {" "}
                    <InputRedio
                      lableText={"No"}
                      name={"SellersItem"}
                      checked={SingleData?.sellersItem === "Disable"}
                      onChange={() =>
                        setSingleData({ ...SingleData, sellersItem: "Disable" })
                      }
                      disabled={disabled}
                    />
                  </div>
                </div>
              </div>
              {
                errors.status && <div style={{ color: "red", fontSize: "12px", fontWeight: "400" }}> {errors.status} </div>
              }
            </div>
          </div>
        </div>
        {/* </form> */}
      </div>
    </div>
  );
};

export default AddItem;
